import i18n from '@/i18n'
import { gm } from './gm'

const jsjky = () => import('@/components/firms/jsjky.vue')
const jhhx = () => import('@/components/firms/jhhx.vue')
const dfyh = () => import('@/components/firms/dfyh.vue')
const jsqt = () => import('@/components/firms/jsqt.vue')
const shsk = () => import('@/components/firms/shsk.vue')
const hdjs = () => import('@/components/firms/hdjs.vue')
const yajs = () => import('@/components/firms/yajs.vue')
const jgs = () => import('@/components/firms/jgs.vue')
const zyf = () => import('@/components/firms/zyf.vue')
const yjjt = () => import('@/components/firms/yjjt.vue')
const jsjs = () => import('@/components/firms/jsjs.vue')
const btkj = () => import('@/components/firms/btkj.vue')
const kld = () => import('@/components/firms/kld.vue')
const jlkj = () => import('@/components/firms/jlkj.vue')
export const groupMap = {
    f0: jsjky, // 姹熻嫃寤虹闄?1
    f1: jhhx, //姹熸捣鏉惂 1
    f2: dfyh, //涓滄柟闆ㄨ櫣1
    f3: jsqt,    //姹熻嫃鎿庡ぉ宸ヤ笟浜掕仈缃戞湁闄愬叕鍙哥畝浠?1
    f4: shsk, //涓婃捣鍦ｅ 1
    f5: hdjs, //瀹忓ぇ寤鸿 1
    f6: yajs,// 姹熻嫃瀹滃畨寤鸿 1
    f7: jgs, // 浣冲浐澹?1
    f8: zyf, // 涓嚎涓?1
    f9: yjjt, // 姹熻嫃鎵缓 1
    f10: jsjs, // 姹熻嫃閿︿笂 1
    f11: btkj, // 鍗椾含璐濆攼銆€锛?    f12: jlkj, // 涔呯摯绉戞妧
    f13: kld, // 涔呯摯绉戞妧
    f14: () => import('@/components/firms/26du/index.vue'),
    f15: () => import('@/components/firms/gdw/index.vue'),
    f16: () => import('@/components/firms/gwjs/index.vue'),
    f17: () => import('@/components/firms/jsjzzyxy/index.vue'),
    f18: () => import('@/components/firms/jslx/index.vue'),
    f19: () => import('@/components/firms/jpyl/index.vue'),
    f20: () => import('@/components/firms/elematic/index.vue'),
    f21: () => import('@/components/firms/dv/index.vue'),
    f22: () => import('@/components/firms/bjaq/index.vue'),
    f23: () => import('@/components/firms/hbok/index.vue'),
    f24: () => import('@/components/firms/kdgj/index.vue'),
    f25: () => import('@/components/firms/kldtl/index.vue'),
    f26: () => import('@/components/firms/lczg/index.vue'),
    f27: () => import('@/components/firms/kbd/index.vue'),
    f28: () => import('@/components/firms/meb/index.vue'),
    f29: () => import('@/components/firms/bhbl/index.vue'),
    f30: () => import('@/components/firms/cztj/index.vue'),
    f31: () => import('@/components/firms/dlly/index.vue'),
    f32: () => import('@/components/firms/jssw/index.vue'),
    f33: () => import('@/components/firms/jywy/index.vue'),
    f34: () => import('@/components/firms/jykj/index.vue'),
    f35: () => import('@/components/firms/jbh/index.vue'),
    f36: () => import('@/components/firms/jlz/index.vue'),
    f37: () => import('@/components/firms/klsk/index.vue'),
    f38: () => import('@/components/firms/nthy/index.vue'),
    f39: () => import('@/components/firms/wxlr/index.vue'),
    f40: () => import('@/components/firms/wxxzh/index.vue'),
    f41: () => import('@/components/firms/nths/index.vue'),
    f42: () => import('@/components/firms/jssx/index.vue'),
    f43: () => import('@/components/firms/hxnj/index.vue'),
    f44: () => import('@/components/firms/jsjr/index.vue'),
    f45: () => import('@/components/firms/sjzxy/index.vue'),
    f46: () => import('@/components/firms/sghjt/index.vue'),
    f47: () => import('@/components/firms/dgsp/index.vue'),
    f48: () => import('@/components/firms/szjz/index.vue'),
    f49: () => import('@/components/firms/szxy/index.vue'),
    f50: () => import('@/components/firms/szylsj/index.vue'),
    f51: () => import('@/components/firms/tsbq/index.vue'),
    f52: () => import('@/components/firms/z52/index.vue'),
    f53: () => import('@/components/firms/z53/index.vue'),
    f54: () => import('@/components/firms/z54/index.vue'),
    f55: () => import('@/components/firms/z55/index.vue'),
    f56: () => import('@/components/firms/z56/index.vue'),
    f57: () => import('@/components/firms/z57/index.vue'),
    f58: () => import('@/components/firms/z58/index.vue'),
    f59: () => import('@/components/firms/z59/index.vue'),
    f60: () => import('@/components/firms/z60/index.vue'),
    f61: () => import('@/components/firms/z61/index.vue'),
    f62: () => import('@/components/firms/z62/index.vue'),
    f63: () => import('@/components/firms/z63/index.vue'),
    f64: () => import('@/components/firms/z64/index.vue'),
    f65: () => import('@/components/firms/z65/index.vue'),
    f66: () => import('@/components/firms/z66/index.vue'),
    f67: () => import('@/components/firms/z67/index.vue'),
    f68: () => import('@/components/firms/z68/index.vue'),
    f69: () => import('@/components/firms/z69/index.vue'),
    f70: () => import('@/components/firms/z70/index.vue'),
    f71: () => import('@/components/firms/z71/index.vue'),
    f72: () => import('@/components/firms/z72/index.vue'),
    f73: () => import('@/components/firms/z73/index.vue'),
    f74: () => import('@/components/firms/z74/index.vue'),
    f75: () => import('@/components/firms/z75/index.vue'),
    f76: () => import('@/components/firms/z76/index.vue'),
    f77: () => import('@/components/firms/z77/index.vue'),
    f78: () => import('@/components/firms/z78/index.vue'),
    f79: () => import('@/components/firms/z79/index.vue'),
    f80: () => import('@/components/firms/z80/index.vue'),
    f81: () => import('@/components/firms/z81/index.vue'),
    f82: () => import('@/components/firms/z82/index.vue'),
    f83: () => import('@/components/firms/z83/index.vue'),
    f84: () => import('@/components/firms/z84/index.vue'),
    f85: () => import('@/components/firms/z85/index.vue'),
    f86: () => import('@/components/firms/z86/index.vue'),
    f87: () => import('@/components/firms/z87/index.vue'),
    f88: () => import('@/components/firms/z88/index.vue'),
}

export const exhibitorLogoFiles = [
    "shoplogo/zs309_logo_1.png",
    "shoplogo/zs309_logo_2.png",
    "shoplogo/zs309_logo_3.png",
    "shoplogo/zs309_logo_4.png",
    "shoplogo/zs309_logo_5.png",
    "shoplogo/zs309_logo_6.png",
    "shoplogo/zs309_logo_7.png",
    "shoplogo/zs309_logo_8.png",
    "shoplogo/zs309_logo_9.png",
    "shoplogo/zs309_logo_10.png",
    "shoplogo/zs309_logo_11.png",
    "shoplogo/zs309_logo_12.png",
    "shoplogo/zs309_logo_13.png",
    "shoplogo/zs309_logo_14.png",
    "shoplogo/zs309_logo_15.png",
    "shoplogo/zs309_logo_16.png",
    "shoplogo/zs309_logo_17.png",
    "shoplogo/zs309_logo_18.png",
    "shoplogo/zs309_logo_19.png",
    "shoplogo/zs309_logo_20.png",
    "shoplogo/zs309_logo_21.png",
    "shoplogo/zs309_logo_22.png",
    "shoplogo/zs309_logo_23.png",
    "shoplogo/zs309_logo_24.png",
    "shoplogo/zs309_logo_25.png",
    "shoplogo/zs309_logo_26.png",
    "shoplogo/zs309_logo_27.png",
    "shoplogo/zs309_logo_28.png",
    "shoplogo/zs309_logo_29.png",
    "shoplogo/zs309_logo_30.png",
    "shoplogo/zs309_logo_31.png",
    "shoplogo/zs309_logo_32.png",
    "shoplogo/zs309_logo_33.png",
    "shoplogo/zs309_logo_34.png",
    "shoplogo/zs309_logo_35.png",
    "shoplogo/zs309_logo_36.png",
    "shoplogo/zs309_logo_37.png",
    "shoplogo/zs309_logo_38.png",
    "shoplogo/zs309_logo_39.png",
    "shoplogo/zs309_logo_40.png",
    "shoplogo/zs309_logo_41.png",
    "shoplogo/zs309_logo_42.png",
    "shoplogo/zs309_logo_43.png",
    "shoplogo/zs309_logo_44.png",
    "shoplogo/zs309_logo_45.png",
    "shoplogo/zs309_logo_46.png",
    "shoplogo/zs309_logo_47.png",
    "shoplogo/zs309_logo_48.png",
    "shoplogo/zs309_logo_49.png",
    "shoplogo/zs309_logo_50.png",
    "shoplogo/zs309_logo_51.png",
    "shoplogo/zs309_logo_52.png",
    "shoplogo/zs309_logo_53.png",
    "shoplogo/zs309_logo_54.png",
    "shoplogo/zs309_logo_55.png",
    "shoplogo/zs309_logo_56.png",
    "shoplogo/zs309_logo_57.png",
    "shoplogo/zs309_logo_58.png",
    "shoplogo/zs309_logo_59.png",
    "shoplogo/zs309_logo_60.png",
    "shoplogo/zs309_logo_61.png",
    "shoplogo/zs309_logo_62.png",
    "shoplogo/zs309_logo_63.png",
    "shoplogo/zs309_logo_64.png",
    "shoplogo/zs309_logo_65.png",
    "shoplogo/zs309_logo_66.png",
    "shoplogo/zs309_logo_67.png",
    "shoplogo/zs309_logo_68.png",
    "shoplogo/zs309_logo_69.png",
    "shoplogo/zs309_logo_70.png",
    "shoplogo/zs309_logo_71.png",
    "shoplogo/zs309_logo_72.png",
    "shoplogo/zs309_logo_73.png",
    "shoplogo/zs309_logo_74.png",
    "shoplogo/zs309_logo_75.png",
    "shoplogo/zs309_logo_76.png",
    "shoplogo/zs309_logo_77.png",
    "shoplogo/zs309_logo_78.png",
    "shoplogo/zs309_logo_79.png",
    "shoplogo/zs309_logo_80.png",
    "shoplogo/zs309_logo_81.png",
    "shoplogo/zs309_logo_82.png",
    "shoplogo/zs309_logo_83.png",
    "shoplogo/zs309_logo_84.png",
    "shoplogo/zs309_logo_85.png",
    "shoplogo/zs309_logo_86.png",
    "shoplogo/zs309_logo_87.png",
    "shoplogo/zs309_logo_88.png",
    "shoplogo/zs309_logo_89.png",
    "shoplogo/zs309_logo_90.png",
    "shoplogo/zs309_logo_91.png",
    "shoplogo/zs309_logo_92.png",
    "shoplogo/zs309_logo_93.png",
    "shoplogo/zs309_logo_94.png",
    "shoplogo/zs309_logo_95.png",
    "shoplogo/zs309_logo_96.png",
    "shoplogo/zs309_logo_97.png",
    "shoplogo/zs309_logo_98.png",
    "shoplogo/zs309_logo_99.png",
    "shoplogo/zs309_logo_100.png",
    "shoplogo/zs309_logo_101.png",
    "shoplogo/zs309_logo_102.png",
    "shoplogo/zs309_logo_103.png",
    "shoplogo/zs309_logo_104.png",
    "shoplogo/zs309_logo_105.png",
    "shoplogo/zs309_logo_106.png",
    "shoplogo/zs309_logo_107.png",
    "shoplogo/zs309_logo_108.png",
    "shoplogo/zs309_logo_109.png",
    "shoplogo/zs309_logo_110.png",
    "shoplogo/zs309_logo_111.png",
    "shoplogo/zs309_logo_112.png",
    "shoplogo/zs309_logo_113.png",
    "shoplogo/zs309_logo_114.png",
    "shoplogo/zs309_logo_115.png",
    "shoplogo/zs309_logo_116.png",
    "shoplogo/zs309_logo_117.png",
    "shoplogo/zs309_logo_118.png",
    "shoplogo/zs309_logo_119.png",
    "shoplogo/zs309_logo_120.png",
    "shoplogo/zs309_logo_121.png",
    "shoplogo/zs309_logo_122.png",
    "shoplogo/zs309_logo_123.png",
    "shoplogo/zs309_logo_124.png",
    "shoplogo/zs309_logo_125.png",
    "shoplogo/zs309_logo_126.png",
    "shoplogo/zs309_logo_127.png",
    "shoplogo/zs309_logo_128.png",
    "shoplogo/zs309_logo_129.png",
    "shoplogo/zs309_logo_130.png",
    "shoplogo/zs309_logo_131.png",
    "shoplogo/zs309_logo_132.png",
    "shoplogo/zs309_logo_133.png",
    "shoplogo/zs309_logo_134.png",
    "shoplogo/zs309_logo_135.png",
    "shoplogo/zs309_logo_136.png",
    "shoplogo/zs309_logo_137.png",
    "shoplogo/zs309_logo_138.png",
    "shoplogo/zs309_logo_139.png",
    "shoplogo/zs309_logo_140.png",
    "shoplogo/zs309_logo_141.png",
    "shoplogo/zs309_logo_142.png",
    "shoplogo/zs309_logo_143.png",
    "shoplogo/zs309_logo_144.png",
    "shoplogo/zs309_logo_145.png",
    "shoplogo/zs309_logo_146.png",
    "shoplogo/zs309_logo_147.png",
    "shoplogo/zs309_logo_148.png",
    "shoplogo/zs309_logo_149.png",
    "shoplogo/zs309_logo_150.png",
    "shoplogo/zs309_logo_151.png",
    "shoplogo/zs309_logo_152.png",
    "shoplogo/zs309_logo_153.png",
    "shoplogo/zs309_logo_154.png",
    "shoplogo/zs309_logo_155.png",
    "shoplogo/zs309_logo_156.png",
    "shoplogo/zs309_logo_157.png",
    "shoplogo/zs309_logo_158.png",
    "shoplogo/zs309_logo_159.png",
    "shoplogo/zs309_logo_160.png",
    "shoplogo/zs309_logo_161.png",
    "shoplogo/zs309_logo_162.png",
    "shoplogo/zs309_logo_163.png",
    "shoplogo/zs309_logo_164.png",
    "shoplogo/zs309_logo_165.png",
    "shoplogo/zs309_logo_166.png",
    "shoplogo/zs309_logo_167.png",
    "shoplogo/zs309_logo_168.png",
    "shoplogo/zs309_logo_169.png",
    "shoplogo/zs309_logo_170.png",
    "shoplogo/zs309_logo_171.png",
    "shoplogo/zs309_logo_172.png",
    "shoplogo/zs309_logo_173.png",
    "shoplogo/zs309_logo_174.png",
    "shoplogo/zs309_logo_175.png",
    "shoplogo/zs309_logo_176.png",
    "shoplogo/zs309_logo_177.png",
    "shoplogo/zs309_logo_178.png",
    "shoplogo/zs309_logo_179.png",
    "shoplogo/zs309_logo_180.png",
    "shoplogo/zs309_logo_181.png",
    "shoplogo/zs309_logo_182.png",
    "shoplogo/zs309_logo_183.png",
    "shoplogo/zs309_logo_184.png",
    "shoplogo/zs309_logo_185.png",
    "shoplogo/zs309_logo_186.png",
    "shoplogo/zs309_logo_187.png",
    "shoplogo/zs309_logo_188.png",
    "shoplogo/zs309_logo_189.png",
    "shoplogo/zs309_logo_190.png",
    "shoplogo/zs309_logo_191.png",
    "shoplogo/zs309_logo_192.png",
    "shoplogo/zs309_logo_193.png",
    "shoplogo/zs309_logo_194.png",
    "shoplogo/zs309_logo_195.png",
    "shoplogo/zs309_logo_196.png",
    "shoplogo/zs309_logo_197.png",
    "shoplogo/zs309_logo_198.png",
    "shoplogo/zs309_logo_199.png",
    "shoplogo/zs309_logo_200.png",
    "shoplogo/zs309_logo_201.png",
    "shoplogo/zs309_logo_202.png",
    "shoplogo/zs309_logo_203.png",
    "shoplogo/zs309_logo_204.png",
    "shoplogo/zs309_logo_205.png",
    "shoplogo/zs309_logo_206.png",
    "shoplogo/zs309_logo_207.png",
    "shoplogo/zs309_logo_208.png",
    "shoplogo/zs309_logo_209.png",
    "shoplogo/zs309_logo_210.png",
    "shoplogo/zs309_logo_211.png",
    "shoplogo/zs309_logo_212.png",
    "shoplogo/zs309_logo_213.png",
    "shoplogo/zs309_logo_214.png",
    "shoplogo/zs309_logo_215.png",
    "shoplogo/zs309_logo_216.png",
    "shoplogo/zs309_logo_217.png",
    "shoplogo/zs309_logo_218.png",
    "shoplogo/zs309_logo_219.png",
    "shoplogo/zs309_logo_220.png",
    "shoplogo/zs309_logo_221.png",
    "shoplogo/zs309_logo_222.png",
    "shoplogo/zs309_logo_223.png",
    "shoplogo/zs309_logo_224.png",
    "shoplogo/zs309_logo_225.png",
    "shoplogo/zs309_logo_226.png",
    "shoplogo/zs309_logo_227.png",
    "shoplogo/zs309_logo_228.png",
    "shoplogo/zs309_logo_229.png",
    "shoplogo/zs309_logo_230.png",
    "shoplogo/zs309_logo_231.png",
    "shoplogo/zs309_logo_232.png",
    "shoplogo/zs309_logo_233.png",
    "shoplogo/zs309_logo_234.png",
    "shoplogo/zs309_logo_235.png",
    "shoplogo/zs309_logo_236.png",
    "shoplogo/zs309_logo_237.png",
    "shoplogo/zs309_logo_238.png",
    "shoplogo/zs309_logo_239.png",
    "shoplogo/zs309_logo_240.png",
    "shoplogo/zs309_logo_241.png",
    "shoplogo/zs309_logo_242.png",
    "shoplogo/zs309_logo_243.png",
    "shoplogo/zs309_logo_244.png",
    "shoplogo/zs309_logo_245.png",
    "shoplogo/zs309_logo_246.png",
    "shoplogo/zs309_logo_247.png",
    "shoplogo/zs309_logo_248.png",
    "shoplogo/zs309_logo_249.png",
    "shoplogo/zs309_logo_250.png",
    "shoplogo/zs309_logo_251.png",
    "shoplogo/zs309_logo_252.png",
    "shoplogo/zs309_logo_253.png",
    "shoplogo/zs309_logo_254.png",
    "shoplogo/zs309_logo_255.png",
    "shoplogo/zs309_logo_256.png",
    "shoplogo/zs309_logo_257.png",
    "shoplogo/zs309_logo_258.png",
    "shoplogo/zs309_logo_259.png",
    "shoplogo/zs309_logo_260.png",
    "shoplogo/zs309_logo_261.png",
    "shoplogo/zs309_logo_262.png",
    "shoplogo/zs309_logo_263.png",
    "shoplogo/zs309_logo_264.png",
    "shoplogo/zs309_logo_265.png",
    "shoplogo/zs309_logo_266.png",
    "shoplogo/zs309_logo_267.png",
    "shoplogo/zs309_logo_268.png",
    "shoplogo/zs309_logo_269.png",
    "shoplogo/zs309_logo_270.png",
    "shoplogo/zs309_logo_271.png",
    "shoplogo/zs309_logo_272.png",
    "shoplogo/zs309_logo_273.png",
    "shoplogo/zs309_logo_274.png",
    "shoplogo/zs309_logo_275.png",
    "shoplogo/zs309_logo_276.png",
    "shoplogo/zs309_logo_277.png",
    "shoplogo/zs309_logo_278.png",
    "shoplogo/zs309_logo_279.png",
    "shoplogo/zs309_logo_280.png",
    "shoplogo/zs309_logo_281.png",
    "shoplogo/zs309_logo_282.png",
    "shoplogo/zs309_logo_283.png",
    "shoplogo/zs309_logo_284.png",
    "shoplogo/zs309_logo_285.png",
    "shoplogo/zs309_logo_286.png",
    "shoplogo/zs309_logo_287.png",
    "shoplogo/zs309_logo_288.png",
    "shoplogo/zs309_logo_289.png",
    "shoplogo/zs309_logo_290.png",
    "shoplogo/zs309_logo_291.png",
    "shoplogo/zs309_logo_292.png",
    "shoplogo/zs309_logo_293.png",
    "shoplogo/zs309_logo_294.png",
    "shoplogo/zs309_logo_295.png",
    "shoplogo/zs309_logo_296.png",
    "shoplogo/zs309_logo_297.png",
    "shoplogo/zs309_logo_298.png",
    "shoplogo/zs309_logo_299.png",
    "shoplogo/zs309_logo_300.png",
    "shoplogo/zs309_logo_301.png",
    "shoplogo/zs309_logo_302.png",
    "shoplogo/zs309_logo_303.png",
    "shoplogo/zs309_logo_304.png",
    "shoplogo/zs309_logo_305.png",
    "shoplogo/zs309_logo_306.png",
    "shoplogo/zs309_logo_307.png",
    "shoplogo/zs309_logo_308.png",
    "shoplogo/zs309_logo_309.png"
]

export const firmsList = exhibitorLogoFiles.map((file) => ({
    img: gm(file),
    name: file,
}))
export const homeNewList = [
    {
        timer: "2025-04-08",        title: i18n.t("newIndex.line11"),
        subtitle: i18n.t(""),
        img: gm("2025-01.jpg"),
        link: "https://mp.weixin.qq.com/s/g4DUfx84ZCcpvD-9p9bwCg"
    },
    {
        timer: "2025-04-07",        title: i18n.t("newIndex.line12"),
        subtitle: i18n.t(""),
        img: gm("2025-02.jpg"),
        link: "https://mp.weixin.qq.com/s/OEkCtAtLY7lItQ4IKHfZIg"
    },
    {
        timer: "2025-04-04",        title: i18n.t("newIndex.line13"),
        subtitle: i18n.t(""),
        img: gm("2025-03.jpg"),
        link: "https://mp.weixin.qq.com/s/FOKg9UC08w87fwnBX8Id2g"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line14"),
        subtitle: i18n.t(""),
        img: gm("2025-04.jpg"),
        link: "https://mp.weixin.qq.com/s/YpmHlwP_Yzq4gMesuHC_HA"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line15"),
        subtitle: i18n.t(""),
        img: gm("2025-05.jpg"),
        link: "https://mp.weixin.qq.com/s/q4nwg2IsP8nXXawItOfXjw"
    },
    {
        timer: "2025-04-03",        title: i18n.t("newIndex.line16"),
        subtitle: i18n.t(""),
        img: gm("2025-06.jpg"),
        link: "https://mp.weixin.qq.com/s/F09wRaZmVHAORbZwNXOUuQ"
    },
    {
        timer: "2025-04-02",        title: i18n.t("newIndex.line17"),
        subtitle: i18n.t(""),
        img: gm("2025-07.jpg"),
        link: "https://mp.weixin.qq.com/s/zN_vOtQpaQrCncAUqssVyQ"
    },
    {
        timer: "2025-04-01",        title: i18n.t("newIndex.line18"),
        subtitle: i18n.t(""),
        img: gm("2025-08.jpg"),
        link: "https://mp.weixin.qq.com/s/trCYFQkQfItdTLI-9Yfqow"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line19"),
        subtitle: i18n.t(""),
        img: gm("2025-09.jpg"),
        link: "https://mp.weixin.qq.com/s/2-uU6R8UE4_zRcqB_9dfuw"
    },
    {
        timer: "2025-03-31",        title: i18n.t("newIndex.line20"),
        subtitle: i18n.t(""),
        img: gm("2025-10.jpg"),
        link: "https://mp.weixin.qq.com/s/sn4YJAdCLWxblzdNAKE2IA"
    },
    {
        timer: "2025-03-28",        title: i18n.t("newIndex.line21"),
        subtitle: i18n.t(""),
        img: gm("2025-11.jpg"),
        link: "https://mp.weixin.qq.com/s/9YaunTeZDTLbdc0vLjt6WQ"
    },
    {
        timer: "2025-03-27",        title: i18n.t("newIndex.line22"),
        subtitle: i18n.t(""),
        img: gm("2025-12.jpg"),
        link: "https://mp.weixin.qq.com/s/1U0sgUp4bWiIk7WAm_nsmw"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line23"),
        subtitle: i18n.t(""),
        img: gm("2025-13.jpg"),
        link: "https://mp.weixin.qq.com/s/EF1ED04tAMpKguSExZly4w"
    },
    {
        timer: "2025-03-25",        title: i18n.t("newIndex.line24"),
        subtitle: i18n.t(""),
        img: gm("2025-14.jpg"),
        link: "https://mp.weixin.qq.com/s/JETBmlZoY9iGGefEUQ9C-w"
    },
    {
        timer: "2025-03-22",        title: i18n.t("newIndex.line25"),
        subtitle: i18n.t(""),
        img: gm("2025-15.jpg"),
        link: "https://mp.weixin.qq.com/s/zKQ69QKjzhihFMMcGE1zsg"
    },
    {
        timer: "2025-03-30",        title: i18n.t("newIndex.line26"),
        subtitle: i18n.t(""),
        img: gm("2025-16.jpg"),
        link: "https://mp.weixin.qq.com/s/vw13-mRpWwa8Ve8MmGI3DQ"
    },
    {
        timer: "2025-03-29",        title: i18n.t("newIndex.line27"),
        subtitle: i18n.t(""),
        img: gm("2025-17.jpg"),
        link: "https://mp.weixin.qq.com/s/5K5FCaaLozDCke64KxL15g"
    },
    {
        timer: "2025-03-26",        title: i18n.t("newIndex.line28"),
        subtitle: i18n.t(""),
        img: gm("2025-18.jpg"),
        link: "https://mp.weixin.qq.com/s/QNkJQi-kGD_RH4bArefswQ"
    },
    {
        timer: "2025-03-07",        title: i18n.t("newIndex.line29"),
        subtitle: i18n.t(""),
        img: gm("2025-19.jpg"),
        link: "https://mp.weixin.qq.com/s/ljD8_h9ruO0rIKCyKTLDig"
    },
    {
        timer: "2025-02-14",        title: i18n.t("newIndex.line30"),
        subtitle: i18n.t(""),
        img: gm("2025-20.jpg"),
        link: "https://mp.weixin.qq.com/s/00fmP1caNOnhYzrg9VL3Uw"
    },
    {
        timer: "2024-12-05",        title: i18n.t("newIndex.line31"),
        subtitle: i18n.t(""),
        img: gm("2025-21.jpg"),
        link: "https://mp.weixin.qq.com/s/RnDYDqAVQBmCwtqA60C_Fw"
    },
    {
        timer: "2024-12-24",        title: i18n.t("newIndex.line32"),
        subtitle: i18n.t(""),
        img: gm("2025-22.jpg"),
        link: "https://mp.weixin.qq.com/s/ALTJrSN938yj8S2cGRv2jQ"
    },
    {
        timer: "2024-12-26",        title: i18n.t("newIndex.line33"),
        subtitle: i18n.t(""),
        img: gm("2025-23.jpg"),
        link: "https://mp.weixin.qq.com/s/f7gpQTTpvMt6TDJpAFJDrA"
    },
    {
        timer: "2024-12-27",        title: i18n.t("newIndex.line34"),
        subtitle: i18n.t(""),
        img: gm("2025-24.jpg"),
        link: "https://mp.weixin.qq.com/s/CqT11yl5la8LlXcIbHML-w"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line1"),
        title: i18n.t("newIndex.line2"),
        img: gm("1-2.png"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-08-10",        title: i18n.t("newIndex.line3"),
        title: i18n.t("newIndex.line4"),
        img: gm("1-3.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-08-18",        title: i18n.t("newIndex.line5"),
        title: i18n.t("newIndex.line6"),
        img: gm("1-4.jpg"),
        link: "https://mp.weixin.qq.com/s/sg_m1zSGWARpQcB3yeLcbg"
    },
    {
        timer: "2023-09-21",        title: i18n.t("newIndex.line35"),
        subtitle: i18n.t(""),
        img: gm("2023-01.jpg"),
        link: "https://mp.weixin.qq.com/s/d-RfUGKnop9EhbzXRvoA9Q"
    },
    {
        timer: "2023-09-26",        title: i18n.t("newIndex.line36"),
        subtitle: i18n.t(""),
        img: gm("2023-02.jpg"),
        link: "https://mp.weixin.qq.com/s/MDY0rH1Sl1mIBwFuyMl3Yw"
    },
    {
        timer: "2023-07-10",        title: i18n.t("newIndex.line37"),
        subtitle: i18n.t(""),
        img: gm("2023-03.jpg"),
        link: "https://mp.weixin.qq.com/s/YTS_9TSOlB1iN9fKtP7pvw"
    },
    {
        timer: "2023-09-16",        title: i18n.t("newIndex.line38"),
        subtitle: i18n.t(""),
        img: gm("2023-04.jpg"),
        link: "https://mp.weixin.qq.com/s/QwORfSUjcBTj4rvgqFDsSw"
    },
    {
        timer: "2023-10-10",        title: i18n.t("newIndex.line39"),
        subtitle: i18n.t(""),
        img: gm("2023-05.jpg"),
        link: "https://mp.weixin.qq.com/s/gtL3q3DNcBgqp46NmCW2WQ"
    },
    {
        timer: "2023-10-12",        title: i18n.t("newIndex.line40"),
        subtitle: i18n.t(""),
        img: gm("2023-06.jpg"),
        link: "https://mp.weixin.qq.com/s/cOSmSLpqPwRMgqY7qgDlYA"
    },
    {
        timer: "2023-08-02",        title: i18n.t("newIndex.line41"),
        subtitle: i18n.t(""),
        img: gm("2023-07.jpg"),
        link: "https://mp.weixin.qq.com/s/MPDzTqxTpbnw1EHoh9sDAw"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line42"),
        subtitle: i18n.t(""),
        img: gm("2023-08.jpg"),
        link: "https://mp.weixin.qq.com/s/z-RCuO1KjKSGqo91AgFOcQ"
    },
    {
        timer: "2023-08-23",        title: i18n.t("newIndex.line43"),
        subtitle: i18n.t(""),
        img: gm("2023-09.jpg"),
        link: "https://mp.weixin.qq.com/s/iw70GyvQ3WsNnyKD2Yr_SA"
    },
    {
        timer: "2023-10-13",        title: i18n.t("newIndex.line44"),
        subtitle: i18n.t(""),
        img: gm("2023-10.jpg"),
        link: "https://mp.weixin.qq.com/s/oA4gXpbv7lC8r0jlDsJTrQ"
    },
    {
        timer: "2023-10-14",        title: i18n.t("newIndex.line45"),
        subtitle: i18n.t(""),
        img: gm("2023-11.jpg"),
        link: "https://mp.weixin.qq.com/s/02nvHTWWb0ttASZy4QMeIQ"
    }
]
